import * as React from "react";
const SvgBarsFilter = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 6H19V7.5H5V6ZM7 11H17V12.5H7V11ZM14 16V17.5H10V16H14Z", fill: "currentColor" }));
export default SvgBarsFilter;
